import React from 'react';
import { cn } from '@/lib/utils';
import { useEnhancedMobile } from '@/hooks/use-enhanced-mobile';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  className?: string;
  children?: React.ReactNode;
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  className,
  children
}) => {
  const { isMobile } = useEnhancedMobile();

  return (
    <div
      className={cn(
        "page-header-banner w-full px-6 py-8",
        isMobile ? "px-4 py-6" : "px-8 py-10",
        className
      )}
    >
      <div className={cn(
          "flex flex-col md:flex-row md:items-baseline md:justify-between gap-2 md:gap-4"
        )}>
          <div className="flex flex-col md:flex-row md:items-center gap-1 md:gap-4">
            <h1 className={cn(
              "page-title",
              isMobile ? "text-3xl" : "text-4xl md:text-5xl"
            )}>
              {title}
            </h1>
            {subtitle && (
              <p className="page-subtitle">
                {subtitle}
              </p>
            )}
          </div>
          {children && (
            <div className="flex items-center gap-3">
              {children}
            </div>
          )}
        </div>
    </div>
  );
};
